import React from 'react'
import styles from './DataRowLabelLine.less'
import { FAIcon } from './FAIcon'
import _ from 'common-tools/LodashHelper'
export class DataRowLabelLine extends React.Component {
  render () {
    const { fields } = this.props
    return (<div className={styles.labelList}>
      {_.map(fields, (info, i) => {
        return <div key={`value_${info.icon}_${i}`} className={styles.labelItem} >
          <FAIcon name={info.icon || 'bar'} helpText={info.helptext} fixedWidth />
          {info.value}
        </div>
      })
      }
    </div>
    )
  }
}
export default DataRowLabelLine
